import React from "react";
import Container from "@/components/marketing/Container";
import SectionHeading from "@/components/marketing/SectionHeading";
import Reveal from "@/components/marketing/Reveal";

export default function SectorWhyUs({ reasons = [], tag, title, subtitle }) {
  return (
    <section className="py-12 lg:py-16 bg-slate/30">
      <Container>
        <Reveal>
        <SectionHeading tag={tag} title={title} subtitle={subtitle} />
        </Reveal>
        <div className="grid md:grid-cols-3 gap-6 lg:gap-8">
          {reasons.map((r, i) => (
            <Reveal key={r.title} variant="card" delay={i * 0.08}>
            <div
              className="bg-white border border-border rounded-xl p-7 lg:p-9 flex flex-col hover:border-cobalt/30 transition-colors"
            >
              <div className="inline-flex items-center justify-center w-12 h-12 rounded-xl bg-cobalt/5 mb-5">
                <r.icon className="w-6 h-6 text-cobalt" strokeWidth={1.75} />
              </div>
              <h3 className="font-heading text-xl font-bold text-bone mb-2">{r.title}</h3>
              <p className="text-sm text-steel leading-relaxed">{r.desc}</p>
            </div>
            </Reveal>
          ))}
        </div>
      </Container>
    </section>
  );
}